import React, { useState } from 'react';
import './Services.css';


const Services = () => {
    const [activeService, setActiveService] = useState('Business Setup');
    const [activeTab, setActiveTab] = useState('Mainland');
    
    // Service data with details for each service
    const servicesData = {
        'Business Setup': {
            title: "Business Setup",
            subtitle: "From Strategy to Launch – We Help You Start Right",
            tabs: {
                'Mainland': [
                    '100% Ownership & Market Access',
                    'LLC: Sole Establishment, Branch Options',
                    'Trade Name Registration & DED License',
                    'Local Sponsorship & PRO Services',
                    'MOA, Legal Docs, Ejari & Office Leasing'
                ],
                'Free Zone': [
                    '100% Foreign Ownership',
                    'No Corporate or Personal Income Tax*',
                    'Full Repatriation of Capital & Profits',
                    'Multiple Visa Options',
                    'Simplified Setup Process & Documentation'
                ],
                'Offshore': [
                    'Asset Protection & Privacy',
                    'No Minimum Capital Requirements',
                    'Corporate Tax Exemptions',
                    'No Annual Audit Requirements',
                    'Investment Holding & International Trading'
                ]
            }
        },
        'UAE Visa Services': {
            title: "UAE Visa Services",
            subtitle: "Comprehensive Visa Solutions for Your Business & Family",
            tabs: {
                'Employment Visas': [
                    'New Work Permit & Employment Visa Processing',
                    'Visa Renewal & Amendments',
                    'Employee Sponsorship Services',
                    'Dependent Visa Processing',
                    'Labour Card & ID Processing'
                ],
                'Investor Visas': [
                    'Golden Visa Applications (5-10 Year)',
                    'Investor Visa Processing',
                    'Partner & Director Visa Processing',
                    'Green Visa Applications',
                    'Startup Visa Program Assistance'
                ],
                'Family Visas': [
                    'Spouse & Children Sponsorship',
                    'Parent Sponsorship Applications',
                    'Domestic Staff Sponsorship',
                    'Family Status Amendment Services',
                    'Multiple Entry Visa Processing'
                ]
            }
        },
        'Accounting & Taxation': {
            title: "Accounting & Taxation",
            subtitle: "Expert Financial Services for UAE Businesses",
            tabs: {
                'Accounting': [
                    'Bookkeeping & Financial Records Maintenance',
                    'Financial Statement Preparation',
                    'Budget Development & Monitoring',
                    'Accounts Receivable & Payable Management',
                    'Payroll Processing & Compliance'
                ],
                'Taxation': [
                    'VAT Registration & Returns Filing',
                    'Corporate Tax Planning & Compliance',
                    'Tax Assessment Assistance',
                    'Excise Tax Management',
                    'International Tax Advisory'
                ],
                'Consulting': [
                    'Financial Analysis & Reporting',
                    'Cash Flow Management',
                    'Business Performance Assessment',
                    'Financial System Implementation',
                    'Audit Preparation & Support'
                ]
            }
        }
    };
    
    const services = [
        {
            icon: (
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="w-12 h-12">
                    <path d="M11.47 3.84a.75.75 0 011.06 0l8.69 8.69a.75.75 0 101.06-1.06l-8.689-8.69a2.25 2.25 0 00-3.182 0l-8.69 8.69a.75.75 0 001.061 1.06l8.69-8.69z" />
                    <path d="M12 5.432l8.159 8.159c.03.03.06.058.091.086v6.198c0 1.035-.84 1.875-1.875 1.875H15a.75.75 0 01-.75-.75v-4.5a.75.75 0 00-.75-.75h-3a.75.75 0 00-.75.75V21a.75.75 0 01-.75.75H5.625a1.875 1.875 0 01-1.875-1.875v-6.198a2.29 2.29 0 00.091-.086L12 5.43z" />
                </svg>
            ),
            title: "Business Setup",
            description: "Get your company up and running in the UAE with ease and efficiency."
        },
        {
            icon: (
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="w-12 h-12">
                    <path fillRule="evenodd" d="M10.788 3.21c.448-1.077 1.976-1.077 2.424 0l2.082 5.007 5.404.433c1.164.093 1.636 1.545.749 2.305l-4.117 3.527 1.257 5.273c.271 1.136-.964 2.033-1.96 1.425L12 18.354 7.373 21.18c-.996.608-2.231-.29-1.96-1.425l1.257-5.273-4.117-3.527c-.887-.76-.415-2.212.749-2.305l5.404-.433 2.082-5.006z" clipRule="evenodd" />
                </svg>
            ),
            title: "UAE Visa Services",
            description: "Streamlined visa assistance for entrepreneurs, employees, and families."
        },
        {
            icon: (
              <svg xmlns="http://www.w3.org/2000/svg" 
     viewBox="0 0 24 24" 
     fill="currentColor" 
     className="w-12 h-12 text-gray-700">
  <path d="M6.75 2A2.25 2.25 0 004.5 4.25v15.5A2.25 2.25 0 006.75 22h10.5A2.25 2.25 0 0019.5 19.75V8.75l-6-6H6.75zm6.375 2.25l4.125 4.125h-4.125V4.25zM12 12a3 3 0 100 6 3 3 0 000-6zm-.75 3a.75.75 0 011.5 0h.75a1.5 1.5 0 11-3 0h.75z"/>
</svg>

            ),
            title: "Accounting & Taxation",
            description: "Stay compliant and financially sound with our expert accounting services."
        }
    ];

    const handleServiceClick = (serviceTitle) => {
        setActiveService(serviceTitle);
        // Set first tab as active when switching services
        setActiveTab(Object.keys(servicesData[serviceTitle].tabs)[0]);
    };

    const renderServiceDetails = () => {
        const service = servicesData[activeService];
        const activeTabContent = service.tabs[activeTab];
        
        return (
            <div className="bg-gray-50 rounded-lg p-8 border-t-4 golden-accent-border shadow-lg">
                <h3 className="text-3xl font-bold text-center mb-2">{service.title}</h3>
                <p className="text-center text-gray-600 mb-8">{service.subtitle}</p>
                
                <div className="flex justify-center mb-6">
                    <div className="inline-flex rounded-lg bg-gray-200 p-1">
                        {Object.keys(service.tabs).map((tab) => (
                            <button
                                key={tab}
                                className={`px-6 py-2 rounded-md text-sm font-medium transition-all duration-200 ${
                                    activeTab === tab 
                                        ? 'bg-black text-white shadow-md' 
                                        : 'text-gray-700 hover:bg-gray-300'
                                }`}
                                onClick={() => setActiveTab(tab)}
                            >
                                {tab}
                            </button>
                        ))}
                    </div>
                </div>
                
                <div className="mt-6">
                    <ul className="space-y-3">
                        {activeTabContent.map((option, idx) => (
                            <li key={idx} className="flex items-start">
                                <div className="flex-shrink-0 w-6 h-6 mt-1">
                                    <svg className="w-6 h-6 golden-accent" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7"></path>
                                    </svg>
                                </div>
                                <span className="ml-3 text-gray-700">{option}</span>
                            </li>
                        ))}
                    </ul>
                </div>
            </div>
        );
    };

    return (
        <div className="py-16 px-4 bg-gradient-to-b from-white to-gray-100">
            <div className="max-w-7xl mx-auto">
                <h2 className="tracking-wide text-black text-center font-bold text-4xl md:text-5xl mb-2">
                    Our Core Services
                </h2>
                <p className="tracking-wide text-black text-center font-light text-base md:text-lg mb-12">
                    Tailored Solutions to Empower your Business in UAE
                </p>

                <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-12">
                    {services.map((service, index) => (
                        <div 
                            key={index} 
                            className={`bg-white rounded-lg shadow-md overflow-hidden transition-all duration-300 hover:shadow-xl hover:translate-y-[-5px] cursor-pointer ${
                                activeService === service.title ? 'ring-2 ring-offset-2 ring-blue-500' : ''
                            }`}
                            onClick={() => handleServiceClick(service.title)}
                        >
                            <div className="golden-accent h-2"></div>
                            <div className="p-8">
                                <div className="flex justify-center mb-6">
                                    <div className="w-20 h-20 golden-accent-light rounded-full flex items-center justify-center golden-accent">
                                        {service.icon}
                                    </div>
                                </div>
                                <h3 className="text-2xl font-semibold text-center mb-4">{service.title}</h3>
                                <p className="text-gray-600 text-center">{service.description}</p>
                                
                                <div className="mt-6 text-center">
                                    <button 
                                        className="inline-flex items-center text-blue-600 font-medium hover:text-blue-800 transition-colors"
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            handleServiceClick(service.title);
                                        }}
                                    >
                                        Learn More
                                        <svg className="w-4 h-4 ml-1" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 5l7 7-7 7"></path>
                                        </svg>
                                    </button>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>

                {renderServiceDetails()}
           
            </div>
        </div>
    );
};

export default Services;